// src/components/cookies/CookieFloatingButton.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import CookieIcon from "@mui/icons-material/Cookie";

const CookieFloatingButton = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <button
      onClick={onClick}
      aria-label={t("cookies.manage")}
      className={`
        fixed bottom-5 left-5 z-[900]
        w-12 h-12 rounded-full
        flex items-center justify-center
        backdrop-blur-[30px]
        transition-all duration-300
        shadow-lg
        hover:scale-105 active:scale-95
        bg-[#036ae5] hover:bg-[#0360d0] text-[#F8FAFC]
      `}
    >
      <CookieIcon
        className={`
          text-[22px]
          transition-colors
        `}
      />
    </button>
  );
};

export default CookieFloatingButton;
